import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DeleteRequestComponent } from './components/delete-request/delete-request.component';
import { SortPipe } from './pipes/sort.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { TitleLanguagePipe } from './pipes/title-language.pipe';
import { SharedServicesModule } from './shared-services/shared-services.module';
import { LoadingComponent } from './components/loading/loading.component';
import { ScdSearchComponent } from './components/scd-search/scd-search.component';
import { SiLoadingSpinnerComponent } from '@siemens/element-ng/loading-spinner';
import { SiFormItemComponent } from '@siemens/element-ng/form';
import { SiTypeaheadDirective } from '@siemens/element-ng/typeahead';

@NgModule({
    declarations: [
        DeleteRequestComponent,
        SortPipe,
        FileSizePipe,
        TitleLanguagePipe,
        LoadingComponent,
        ScdSearchComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslatePipe,
        SharedServicesModule,
        SiLoadingSpinnerComponent,
        SiFormItemComponent,
        SiTypeaheadDirective
    ],
    exports: [
        DeleteRequestComponent,
        SortPipe,
        ReactiveFormsModule,
        FileSizePipe,
        TranslatePipe,
        TitleLanguagePipe,
        SharedServicesModule,
        LoadingComponent,
        ScdSearchComponent
    ]
})
export class SharedModule {}
